import type React from 'react'
import { useState } from 'react'

import { Button, AlternateButton } from '@/components/DEPRECATED_UI/Button'
import SlideInSidebar from '@/components/DEPRECATED_UI/SlideInSidebar'
import TextInput from '@/components/DEPRECATED_UI/TextInput'
import { Container, ErrorContainer } from '@/components/Style/Common'
import { graphQLQuery } from '@/hooks/hooks'
import type { FetchSingleApplication } from '@/hooks/useSubject'
import QUERIES from '@/lib/graphql'

interface SubjectData {
  customerId: string
  applicationId: string
  subjectId: string
}

interface Props {
  setOpen: (open: boolean) => void
  subjectData: SubjectData
  fetchSingleApplication: FetchSingleApplication
  initialPrice: number
  assetPrice: number
}

const UpdatePriceSharePanel: React.FC<Props> = ({
  setOpen,
  subjectData,
  fetchSingleApplication,
  initialPrice,
  assetPrice,
}) => {
  const [sending, setSending] = useState(false)
  const [error, setError] = useState(false)
  const [priceShare, setPriceShare] = useState(initialPrice.toString())

  function handleSubmit(e?: React.FormEvent) {
    if (e) {
      e.preventDefault()
    }
    setSending(true)
    setError(false)

    graphQLQuery({
      query: QUERIES.updatePriceShare,
      variables: {
        customerId: subjectData.customerId,
        applicationId: subjectData.applicationId,
        subjectId: subjectData.subjectId,
        priceShare: +priceShare,
      },
    })
      .then(resData => resData.json())
      .then(data => {
        console.log(data)
        if (data.errors) {
          setError(true)
          setSending(false)
        } else {
          setOpen(false)
          setSending(false)
          fetchSingleApplication(subjectData.customerId, subjectData.subjectId)
        }
      })
      .catch(err => {
        console.log(err)
        setError(true)
        setSending(false)
      })
  }

  return (
    <SlideInSidebar
      onClose={() => setOpen(false)}
      header={
        <div>
          <h2>Update Price Share</h2>
        </div>
      }
      content={
        <Container onSubmit={handleSubmit}>
          <div>
            <h2>Total Tenancy Price</h2>£{assetPrice}
          </div>
          <div>
            <h2>Price Share (£)</h2>
            <TextInput
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                setPriceShare(e.target.value)
              }}
              value={priceShare}
              label="Price Share"
            />
          </div>
          <ErrorContainer>
            {error && (
              <p>
                <strong>Error:</strong> Failed to update price share. Please retry in a
                few minutes and contact support if issues persist.
              </p>
            )}
          </ErrorContainer>
        </Container>
      }
      footer={
        <div>
          <AlternateButton onClick={() => setOpen(false)}>Cancel</AlternateButton>
          <Button disabled={sending} onClick={() => handleSubmit()}>
            Confirm
          </Button>
        </div>
      }
    />
  )
}

export default UpdatePriceSharePanel
